import { Validator } from './validator';

export class SingleSelectionValidator extends Validator {
  validateHelper({ data, configuration }) : string | null {
    const {
      selectedOption,
    } = data;

    const { options, isRequired } = configuration;

    if (selectedOption == null && isRequired) {
      return 'NoOptionSelected';
    }
    for (let i = 0; i < options.length; i += 1) {
      const {
        hasInput,
        key,
        maxLength,
      } = options[i];
      if (hasInput && key === selectedOption) {
        if ((data[key] == null || data[key].length === 0) && isRequired) {
          return 'InputIsEmpty';
        } else if (maxLength && data[key] && data[key].length > maxLength) {
          return 'InputTooLong';
        }
      }
    }
    return null;
  }

  validate({ data, configuration }) {
    return this.validateHelper({ data, configuration }) == null;
  }

  getError({ data, configuration, i18n }) {
    let error = {};
    const { options, isRequired } = configuration;

    for (let i = 0; i < options.length; i += 1) {
      const {
        hasInput,
        key,
        maxLength,
      } = options[i];
      if (hasInput) {
        if ((data[key] == null || data[key].length === 0) && isRequired) {
          error = {
            ...error,
            [key]: i18n.getString(_TL_('Please fill in this field')),
          };
        } else if (maxLength && data[key] && data[key].length > maxLength) {
          error = {
            ...error,
            [key]: i18n.getString(_TL_('Field should not exceed {{maxLength}} characters'), { maxLength }),
          };
        }
      }
    }
    return error;
  }

  isAnswered({ data, configuration, i18n }) {
    let error;
    const {
      selectedOption,
    } = data;
    const { isRequired } = configuration;

    if (selectedOption == null && isRequired) {
      error = i18n.getString(_TL_('Please answer this question'));
    }
    return error;
  }
}
